import { constants } from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";
import { anchorCss } from "@/view/ActionsDropdown/ActionsDropdownAnchorItem/ActionsDropdownAnchorItem.style";

const { colors } = constants;
const darkGrey = colors.ui.neutral[700];
const lightGrey = colors.ui.neutral[300];

export const popOutOptionCss = (isSelected = false, disabled = false) => ({
  // Using only the styles from ActionsDropdownAnchorItem
  ...anchorCss,
  alignItems: "center",
  background: isSelected && greyDarkWithOpacity,
  ...(isSelected ? { color: darkGrey } : {}),
  display: "flex",
  margin: "4px 0",
  padding: "8px 16px",
  position: "relative",

  ...(disabled
    ? {
        cursor: "not-allowed",
        pointerEvents: "none !important",
        opacity: 0.4,
      }
    : {}),

  svg: {
    height: "25px",
    width: "25px",
  },

  "&[disabled]": {
    color: lightGrey,
    "&:hover": {
      color: lightGrey,
    },
  },
});

// This hides the icon indicating open in a new tab on links
export const hideOpenInNewTabIconCss = {
  display: "none",
};

export const buttonContentsWrapperCss = {
  display: "flex",
  alignItems: "flex-start",
  width: "100%",

  "& span:nth-of-type(2)": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  "& span:nth-of-type(2) > svg": {
    width: "12px",
    height: "12px",
    marginRight: "5px",

    path: {
      stroke: lightGrey,
      strokeWidth: "3px",
    },
    circle: {
      fill: lightGrey,
      strokeWidth: "3px",
    },
  },
};

export const iconWrapperCss = {
  display: "flex",
};

export const buttonTextCss = {
  marginLeft: "8px",
  width: "100%",
  textAlign: "left",
};
